export const EVENT_TYPES = {
  concierto:   { label: 'Concierto',             emoji: '🎵', color: '#7C3AED' },
  deportivo:   { label: 'Deportivo',             emoji: '⚽', color: '#059669' },
  politico:    { label: 'Político',              emoji: '🏛', color: '#1A56DB' },
  corporativo: { label: 'Corporativo',           emoji: '💼', color: '#0D1B2A' },
};

export const EVENT_STATUS = {
  planeacion: { label: 'En Planeación', bg: 'bg-blue-100 text-blue-800 border-blue-200',   dot: 'bg-blue-600'  },
  en_curso:   { label: 'En Curso',      bg: 'bg-green-100 text-green-800 border-green-200', dot: 'bg-green-600 animate-pulse' },
  finalizado: { label: 'Finalizado',    bg: 'bg-slate-100 text-slate-600 border-slate-300', dot: 'bg-slate-400' },
  auditado:   { label: 'Auditado',      bg: 'bg-purple-100 text-purple-800 border-purple-200', dot: 'bg-purple-600' },
};

export const RISK_LEVEL = {
  bajo:  { label: 'BAJO',  bg: 'bg-green-100 text-green-800 border-green-200',   bar: '#15803D' },
  medio: { label: 'MEDIO', bg: 'bg-yellow-100 text-yellow-800 border-yellow-200', bar: '#CA8A04' },
  alto:  { label: 'ALTO',  bg: 'bg-red-100 text-red-800 border-red-200',         bar: '#DC2626' },
};

export const CROWD_MANAGEMENT = {
  parados: 'Parados',
  sentados: 'Sentados',
  hibrido: 'Híbrido',
};

export const AGE_RANGES = ['Menos de 18', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'];

export const AUDIENCE_TYPES = [
  { id: 'consumo_alcohol', label: 'Consumo de alcohol' },
  { id: 'familiares',      label: 'Familiares' },
  { id: 'corporativos',    label: 'Corporativos' },
  { id: 'prensa',          label: 'Prensa' },
  { id: 'vip',             label: 'VIP' },
];

export const STATUS_TRANSITIONS = {
  planeacion: ['en_curso'],
  en_curso:   ['finalizado'],
  finalizado: ['auditado'],
  auditado:   [],
};

export const TIMELINE_KEYS = [
  { key: 'setup_start',   label: 'Montaje',               icon: '🔧' },
  { key: 'doors_open',    label: 'Apertura de puertas',   icon: '🚪' },
  { key: 'event_start',   label: 'Inicio del evento',     icon: '▶' },
  { key: 'event_end',     label: 'Fin del evento',        icon: '⏹' },
  { key: 'teardown_date', label: 'Desmontaje',            icon: '📦' },
];

export function getDaysLabel(dateStr) {
  if (!dateStr) return null;
  const now = new Date();
  const d = new Date(dateStr);
  const diff = Math.ceil((d - now) / (1000 * 60 * 60 * 24));
  if (diff > 1) return { text: `En ${diff} días`, color: diff <= 7 ? 'text-orange-600' : 'text-slate-500' };
  if (diff === 1) return { text: 'Mañana', color: 'text-orange-600' };
  if (diff === 0) return { text: 'Hoy', color: 'text-green-600 font-bold' };
  if (diff === -1) return { text: 'Ayer', color: 'text-slate-400' };
  return { text: `Hace ${Math.abs(diff)} días`, color: 'text-slate-400' };
}
